import { z } from "zod";
export const FilterFieldSchema = z.enum([
    "FROM_ADDRESS",
    "FROM_DOMAIN",
    "SUBJECT_CONTAINS",
]);
export const FILTER_FIELDS = [
    "FROM_ADDRESS",
    "FROM_DOMAIN",
    "SUBJECT_CONTAINS",
];
export const FILTER_FIELD_LABELS = {
    FROM_ADDRESS: "Mittente esatto",
    FROM_DOMAIN: "Dominio mittente",
    SUBJECT_CONTAINS: "Oggetto contiene",
};
export const FilterActionSchema = z.enum(["IGNORE", "FLAG_IMPORTANT"]);
export const FILTER_ACTIONS = ["IGNORE", "FLAG_IMPORTANT"];
export const FILTER_ACTION_LABELS = {
    IGNORE: "Ignora",
    FLAG_IMPORTANT: "Segnala importante",
};
export const MailboxFilterRuleSchema = z.object({
    id: z.string(),
    mailboxId: z.string(),
    field: FilterFieldSchema,
    pattern: z.string(),
    action: FilterActionSchema,
    isActive: z.boolean(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const FilterRuleListResponseSchema = z.object({
    items: z.array(MailboxFilterRuleSchema),
});
const patternField = z
    .string()
    .trim()
    .min(1, "Il pattern non può essere vuoto")
    .max(255);
export const FilterRuleCreateSchema = z.object({
    field: FilterFieldSchema,
    pattern: patternField,
    action: FilterActionSchema.optional(),
    isActive: z.boolean().optional(),
});
export const FilterRuleUpdateSchema = z
    .object({
    field: FilterFieldSchema.optional(),
    pattern: patternField.optional(),
    action: FilterActionSchema.optional(),
    isActive: z.boolean().optional(),
})
    .refine((v) => Object.keys(v).length > 0, {
    message: "Almeno un campo deve essere aggiornato",
});
//# sourceMappingURL=filterRules.js.map